import { Loading } from "./loading";
import { AppInit } from "./appinit";
import { TweetView } from "./tweetview";
import 'lazysizes';

// グローバル公開
declare global {
    interface Window {
        Loading: typeof Loading;
        AppInit: typeof AppInit;
        TweetView: typeof TweetView;
    }
}
declare namespace twttr {
    namespace widgets {
        /**
         * Dynamically creates a tweet embed.
         * @param tweetId The ID of the tweet to embed.
         * @param element The DOM element to insert the tweet into.
         * @param options Optional: Configuration options for the embed.
         * @returns A Promise that resolves with the embedded tweet's HTMLElement (usually an iframe).
         */
        function createTweet(
            tweetId: string,
            element: HTMLElement,
            options?: {
                theme?: 'light' | 'dark';
                cards?: 'hidden' | 'visible';
                conversation?: 'none' | 'all';
                align?: 'left' | 'right' | 'center';
                width?: number | string;
                lang?: string;
                [key: string]: any; // その他のオプションに対応
            }
        ): Promise<HTMLElement>; // Promise<HTMLElement> を返すことを明示

        /**
         * Scans a DOM element for Twitter widgets and renders them.
         * @param element The DOM element to scan for widgets.
         * @returns A Promise that resolves with an array of rendered widget HTMLElements.
         */
        function load(element?: HTMLElement): Promise<HTMLElement[]>; // Promise<HTMLElement[]> を返すことを明示
    }

    // 他の twttr プロパティが必要な場合もここに定義
    const ready: (callback: () => void) => void;
    // ... 必要に応じて他の型も定義
}

// グローバルな window オブジェクトに twttr を追加
interface Window {
    twttr?: typeof twttr;
}
window.Loading = Loading;
window.AppInit = AppInit;
window.TweetView = TweetView;

